module.exports = __webpack_public_path__ + "img/gold_img.e8770cf7.png";